import React from "react";
import LeagueListItem, { getColumnLabel } from "./LeagueListItem";

function LeagueList({ leagues }) {
	if (!leagues?.length) {
		return <p className='mb-0'>No hay ligas para mostrar.</p>;
	}

	const columns = Object.keys(leagues[0]).filter(
		(column) => column !== "uniqueIdentifier"
	);

	return (
		<div className='table-responsive'>
			<table className='table table-bordered table-hover align-middle'>
				<thead className='table-dark'>
					<tr>
						{columns.map((column) => (
							<th key={column} scope='col'>
								{getColumnLabel(column)}
							</th>
						))}
						<th scope='col'>Acciones</th>
					</tr>
				</thead>
				<tbody>
					{leagues.map((league) => (
						<LeagueListItem
							columns={columns}
							key={league.uniqueIdentifier}
							league={league}
						/>
					))}
				</tbody>
			</table>
		</div>
	);
}

export default LeagueList;